module.exports = __webpack_public_path__ + "f0aabcf6aee2852f81836460cf271807.png";